var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.359375,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#E9F8F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_463_916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4004 40.3594C38.4004 39.9351 38.569 39.5281 38.869 39.228C39.1691 38.928 39.576 38.7594 40.0004 38.7594C40.4247 38.7594 40.8317 38.928 41.1318 39.228C41.4318 39.5281 41.6004 39.9351 41.6004 40.3594C41.6004 40.7837 41.4318 41.1907 41.1318 41.4908C40.8317 41.7908 40.4247 41.9594 40.0004 41.9594C39.576 41.9594 39.1691 41.7908 38.869 41.4908C38.569 41.1907 38.4004 40.7837 38.4004 40.3594Z",
    fill: "#179D82"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9998 29.1594C37.0294 29.1594 34.1806 30.3394 32.0802 32.4398C29.9798 34.5402 28.7998 37.389 28.7998 40.3594C28.7998 43.3298 29.9798 46.1786 32.0802 48.279C34.1806 50.3794 37.0294 51.5594 39.9998 51.5594C42.9702 51.5594 45.819 50.3794 47.9194 48.279C50.0198 46.1786 51.1998 43.3298 51.1998 40.3594C51.1998 37.389 50.0198 34.5402 47.9194 32.4398C45.819 30.3394 42.9702 29.1594 39.9998 29.1594ZM39.9998 35.5594C38.7268 35.5594 37.5059 36.0651 36.6057 36.9653C35.7055 37.8655 35.1998 39.0864 35.1998 40.3594C35.1998 41.6325 35.7055 42.8534 36.6057 43.7535C37.5059 44.6537 38.7268 45.1594 39.9998 45.1594C41.2728 45.1594 42.4937 44.6537 43.3939 43.7535C44.2941 42.8534 44.7998 41.6325 44.7998 40.3594C44.7998 39.0864 44.2941 37.8655 43.3939 36.9653C42.4937 36.0651 41.2728 35.5594 39.9998 35.5594Z",
    fill: "#179D82"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 16.3594C33.6348 16.3594 27.5303 18.8879 23.0294 23.3888C18.5286 27.8897 16 33.9942 16 40.3594C16 46.7246 18.5286 52.8291 23.0294 57.3299C27.5303 61.8308 33.6348 64.3594 40 64.3594C46.3652 64.3594 52.4697 61.8308 56.9706 57.3299C61.4714 52.8291 64 46.7246 64 40.3594C64 33.9942 61.4714 27.8897 56.9706 23.3888C52.4697 18.8879 46.3652 16.3594 40 16.3594ZM25.6 40.3594C25.6 36.5403 27.1171 32.8776 29.8177 30.177C32.5182 27.4765 36.1809 25.9594 40 25.9594C43.8191 25.9594 47.4818 27.4765 50.1823 30.177C52.8829 32.8776 54.4 36.5403 54.4 40.3594C54.4 44.1785 52.8829 47.8412 50.1823 50.5417C47.4818 53.2422 43.8191 54.7594 40 54.7594C36.1809 54.7594 32.5182 53.2422 29.8177 50.5417C27.1171 47.8412 25.6 44.1785 25.6 40.3594Z",
    fill: "#179D82"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_463_916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(16 16.3594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission);
export default __webpack_public_path__ + "static/media/mission.2dd78b37190cba7455bfe5f496bb5a5b.svg";
export { ForwardRef as ReactComponent };